<!-- Header -->
<div class="flex flex-row flex-wrap items-center justify-end py-4 sm:px-6 px-2 bg-accent-900">
  <div class="flex flex-row flex-grow justify-center items-center" style="min-width: 100px">
    <button
      mat-icon-button
      [ngClass]="isMenuNeeded ? 'hidden' : 'block sm:hidden'"
      class="self-start mt-1 flex-grow-0"
      (click)="toggleDashboardMenu()"
    >
      <mat-icon svgIcon="mat_outline:menu"></mat-icon>
    </button>

    <div class="flex flex-col flex-grow mt-4">
      <!-- Breadcrumbs -->
      <ng-content select="[breadCrumbs]"></ng-content>

      <!-- Title -->
      <div class="flex-1 flex flex-row min-w-0 pt-2 sm:pt-0">
        <h1
          class="flex items-center text-2xl md:text-2xl font-extrabold tracking-tight leading-7 truncate"
        >
          <div class="flex items-center">
            <ng-content select="[title]"></ng-content>
          </div>
        </h1>
      </div>

      <!-- Submenu -->
      <div class="flex flex-row flex-0 sm:items-center mb-3 sm:mb-0">
        <ng-content select="[subMenu]"></ng-content>
      </div>
    </div>
  </div>

  <!-- View Actions -->
  <div class="flex flex-col sm:items-center sm:justify-between justify-end mb-3 sm:mb-0">
    <!-- View Actions and Title -->
    <div class="flex flex-row min-w-0 pt-2 sm:pt-0 items-center justify-between w-full">
      <h1 class="text-2xl md:text-2xl font-extrabold tracking-tight leading-7 truncate">
        <div class="flex items-center capitalize">
          <ng-content select="[viewActions]"></ng-content>
        </div>
      </h1>
    </div>

    <!-- Actions (underneath View Actions) -->
    <div class="flex flex-row justify-end w-full mt-2">
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>
</div>
